import React from 'react'
import Errors from '../errors'

const ErrorsEs = () => {
    return <Errors languageCode="es" />
}

export default ErrorsEs
